// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2poYNIfc{align-items:center;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background-color:rgba(0,0,0,.5);display:flex;height:100vh;height:100dvh;justify-content:center;left:0;padding:1rem;position:fixed;top:0;width:100vw;z-index:100}.-tUs-\\+EE{border-radius:8px;max-height:100%;max-width:100%}.iRUSLa8A{color:#fff;height:100%;position:absolute;top:0;transition:background-color .15s;width:10vw}.iRUSLa8A:hover{background-color:hsla(0,0%,100%,.1)}.iRUSLa8A:after{left:50%;position:absolute;top:50%;transform:scale(2,4) translate(-50%,-50%)}.Gg3rH7wQ{left:0}.Gg3rH7wQ:after{content:\"◄\"}.dPIiFEs2{right:0}.dPIiFEs2:after{content:\"►\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"modal": "_2poYNIfc",
	"modalImg": "-tUs-+EE",
	"modalButton": "iRUSLa8A",
	"modalPrev": "Gg3rH7wQ",
	"modalNext": "dPIiFEs2"
};
module.exports = ___CSS_LOADER_EXPORT___;
